import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FabricAdditionalAttributesTag = React.forwardRef(
  ({ children, isCleaningCode = false }, ref) => (
    <div
      className={classNames(
        'text-xs font-bold bg-gray-light8 text-gray-light1 px-2 py-1 mt-2 mr-1 mb-1 ml-0 flex flex-row items-center capitalize rounded-[.125rem]',
        {
          'cursor-default': !isCleaningCode,
          'cursor-pointer': isCleaningCode,
        }
      )}
      ref={ref}
    >
      {children}
    </div>
  )
);

FabricAdditionalAttributesTag.propTypes = {
  children: PropTypes.node.isRequired,
  isCleaningCode: PropTypes.bool,
};

export default FabricAdditionalAttributesTag;
